import _ from 'lodash';

export const selectHomeownerOnboardingForm = state => _.get(state, ['homeownerOnboardingForm'], {});

export const selectHomeownerOnboardingFormData = state => _.get(selectHomeownerOnboardingForm(state), ['data'], {});
